<template>
    <chats-store
        ref="chats_store"
        @success="onChatsStoreSuccess"
    >
        <messages-store
            ref="messages_store"
            :include="['chat']"
            @success="onMessagesStoreSuccess"
        >
            <div class="p-6">
                <template v-if="message && tenant">
                    <base-loading
                        loading-text="Sending message..."
                    />
                </template>

                <template v-else>
                    Error: Could not find message.
                </template>
            </div>
        </messages-store>
    </chats-store>
</template>

<script>
    import _ from 'lodash'
    import ChatsStore from '../../../../components/chats-store'
    import MessagesStore from '../../../../components/messages-store'

    export default {
        components: {
            ChatsStore,
            MessagesStore
        },
        computed: {
            message () {
                return _.preload('message')
            },
            tenant () {
                return _.preload('tenant')
            }
        },
        mounted () {
            if (this.message) {
                this.$refs.chats_store.store({
                    personas: this.message.personas
                })
            }
        },
        methods: {
            onChatsStoreSuccess ({ data: chat }) {
                this.$refs.messages_store.store({
                    chat: chat.uuid,
                    text: this.message.text
                })
            },
            onMessagesStoreSuccess ({ data: message }) {
                window.location = this.$laroute.route('dashboard.tenants.chats.show', {
                    tenant: _.get(this.tenant, 'data.uuid'),
                    message: message.chat.uuid
                })
            }
        }
    }
</script>
